import React from 'react';
import styled from '@emotion/styled';

import { useStateBus } from '~/state/bridge';
import AdPlacementClient from '~/state/AdPlacement/client';
import { getPlacement, getIsInstagramSelected } from '~/state/AdPlacement/selectors';
import { getLeadAdEnabled } from '~/state/LeadAds/selectors';
import SectionToggle from '~/theseus/components/SectionToggle';
import CheckboxInner from '~/theseus/components/Form/Checkbox';

const handleChange = e => AdPlacementClient.placement.change(e.target.id);
const handleInstagramEnable = () => AdPlacementClient.instagramPlacement.change();

const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  label { 
    border-radius: 0;

    &:not(:first-of-type) {
      border-top: none;
    }

    &:first-of-type {
      border-radius: 4px 4px 0 0;
    }

    &:last-of-type {
      border-radius: 0 0 4px 4px;
    }
  }
`;

const Checkbox = ({ id, ...rest }) => {
  const isSelected = useStateBus(getPlacement(id));

  return <CheckboxInner value={isSelected} id={id} {...rest} />;
};

const Radio = props => <Checkbox type="radio" {...props} />;

export function AdPlacement() {
  const instagramSelected = useStateBus(getIsInstagramSelected);
  const leadAdEnabled = useStateBus(getLeadAdEnabled);

  return (
    <div className="campaign__placement">
      <h3>Placement</h3>
      <FieldContainer>
        <Checkbox id="desktop-feed" label="Desktop Feed" onChange={handleChange} />
        <Checkbox id="mobile-feed" label="Mobile Feed" onChange={handleChange} />
        <Checkbox
          id="mobile-external"
          label="Mobile External"
          disabled={leadAdEnabled}
          onChange={handleChange}
        />
        <Checkbox
          id="right-column"
          label="Right Column"
          disabled={leadAdEnabled}
          onChange={handleChange}
        />
        <Checkbox id="instagram" label="Instagram" value={instagramSelected} onChange={handleInstagramEnable} />
        <SectionToggle enabledOn={instagramSelected}>
          <Radio name="instagram-placement" id="instagram-story" label="Instagram Story" onChange={handleChange} />
          <Radio name="instagram-placement" id="instagram-feed" label="Instagram Feed" onChange={handleChange} />
        </SectionToggle>
      </FieldContainer>
    </div>
  );
}
